import React from "react";
import { WarningCircle, Wrench, Envelope, Phone, ArrowRight } from "@phosphor-icons/react";

export default function MaintenancePage({ settings }) {
  const msg = settings?.maintenance_message ||
    "We're currently performing scheduled maintenance to improve your experience.";
  const eta = settings?.maintenance_eta;
  const email = settings?.support_email;
  const phone = settings?.support_phone;

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md text-center">
        {/* Logo */}
        <div className="flex items-center gap-2 justify-center mb-10">
          <div className="h-10 w-10 rounded-xl flex items-center justify-center font-black text-white"
               style={{ background: "var(--primary)", border: "1.5px solid var(--ink)", boxShadow: "2px 2px 0 0 var(--ink)" }}>
            RA
          </div>
          <span className="display font-black text-2xl">Rating Ally</span>
        </div>

        {/* Card */}
        <div className="card-pop p-8 sm:p-10" style={{ background: "#fff", borderColor: "#FFB347" }}>
          {/* Icon */}
          <div className="mx-auto h-16 w-16 rounded-2xl bg-orange-100 flex items-center justify-center mb-5"
               style={{ border: "2px solid var(--ink)" }}>
            <Wrench size={32} weight="bold" className="text-orange-600" />
          </div>

          {/* Headline */}
          <h1 className="display text-2xl sm:text-3xl font-black tracking-tighter mb-3">
            Rating Ally is Under Maintenance
          </h1>

          {/* Message */}
          <p className="text-[var(--ink-muted)] text-sm leading-relaxed mb-2">
            {msg}
          </p>
          <p className="text-[var(--ink-muted)] text-sm leading-relaxed mb-5">
            Our team is working to bring everything back online as quickly as possible.
          </p>

          {/* ETA */}
          {eta && (
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-orange-50 text-orange-700 text-sm font-bold mb-5"
                 style={{ border: "1.5px solid #FFB347" }}>
              <WarningCircle size={16} weight="fill" />
              Expected back: {eta}
            </div>
          )}

          {!eta && (
            <p className="text-xs font-bold uppercase tracking-widest text-[var(--ink-muted)] mb-5">
              We'll be live again soon.
            </p>
          )}

          {/* Divider */}
          <div className="border-t my-5" style={{ borderColor: "var(--border-soft)" }} />

          {/* Support section */}
          <p className="text-sm font-bold text-[var(--ink)] mb-3">
            Need help or have urgent questions?
          </p>

          <div className="space-y-2">
            {email && (
              <a href={`mailto:${email}`}
                 className="flex items-center justify-center gap-2 text-sm font-medium text-[var(--primary)] hover:underline">
                <Envelope size={16} />
                {email}
              </a>
            )}
            {phone && (
              <a href={`tel:${phone}`}
                 className="flex items-center justify-center gap-2 text-sm font-medium text-[var(--primary)] hover:underline">
                <Phone size={16} />
                {phone}
              </a>
            )}
          </div>

          {email && (
            <a href={`mailto:${email}`}
               className="btn-primary w-full justify-center mt-6 inline-flex">
              Contact Support <ArrowRight size={16} weight="bold" />
            </a>
          )}
        </div>

        {/* Footer */}
        <p className="text-xs text-[var(--ink-muted)] mt-6">
          &copy; {new Date().getFullYear()} Rating Ally. All rights reserved.
        </p>
      </div>
    </div>
  );
}